import React, { useState } from 'react'
import { useRef } from 'react';
import { useEffect } from 'react';

import { useContext } from 'react'

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Autocomplete, Box, Button, CircularProgress, FormControl, FormControlLabel, FormLabel, Grid2, IconButton, InputAdornment, InputLabel, MenuItem, OutlinedInput, Radio, RadioGroup, Select, TextField, Typography } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { AuthContext } from '../../utils/AuthContext';
import { registerAdmin, registerAgent } from '../../services/AuthService';
import { toast } from 'react-toastify';
import CheckIcon from '@mui/icons-material/Check';
import { fetchAgentsFromCMS, updateAgent, fetchAllUsers } from '../../services/UsersService';



function UserFormDialog({ dialogOpen, setDialogOpen, callback, mode, userParam, selectedUser, userType, setUserType }) {

    const { auth } = useContext(AuthContext);


    const [agentId, setAgentId] = useState('');
    const [fullName, setFullName] = useState('');
    const [nickName, setNickName] = useState('');
    const [email, setEmail] = useState('');
    const [contactNo, setContactNo] = useState('');
    const [contactNo2, setContactNo2] = useState('');
    const [status, setStatus] = useState('');
    const [dateOfBirth, setDateOfBirth] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [agents, setAgents] = useState([]);


    const [agentIdError, setAgentIdError] = useState('');
    const [fullNameError, setFullNameError] = useState('');
    const [nickNameError, setNickNameError] = useState('');
    const [emailError, setEmailError] = useState('');
    const [contactNoError, setContactNoError] = useState('');
    const [contactNoError2, setContactNoError2] = useState('');
    const [statusError, setStatusError] = useState('');
    const [dateOfBirthError, setDateOfBirthError] = useState('');
    const [passwordError, setPasswordError] = useState('');
    const [confirmPasswordError, setConfirmPasswordError] = useState('');

    // const [userType, setUserType] = useState('Agent');

    const [isLoading, setLoading] = useState(false);

    useEffect(() => {
        if (selectedUser === null) {
            clearForm();
        } else {
            setAgentId(selectedUser.agent?.agent_id);
            setFullName(selectedUser.full_name);
            setNickName(selectedUser.nick_name);
            setContactNo(selectedUser.agent?.contact_number);
            setContactNo2(selectedUser.agent?.secondary_number);
            setEmail(selectedUser.email);
            setStatus(selectedUser.status);
            setDateOfBirth(selectedUser.date_of_birth);
        }
    }, [selectedUser]);


    const dialogRef = useRef();



    useEffect(() => {

        if (dialogOpen) {
            setTimeout(() => {
                dialogRef.current.getElementsByClassName('MuiInputBase-input')[0].focus();
            }, 100)

            clearErrors();
        }

        if (userParam) {
            setFullName(userParam.agent_name)
        }

    }, [dialogOpen, userParam]);

    useEffect(() => {
        if (auth.token && dialogOpen === true && userType === 'Agent') {
            fetchAgentsFromCMS({ token: auth.token }).then(res => {
                const agents = res.data.agents;
                fetchAllUsers({ token: auth.token }).then(usersRes => {
                    const registeredEmails = usersRes.data.map(user => user.email);
                    const filteredAgents = agents.filter(agent => !registeredEmails.includes(agent.email));
                    setAgents(filteredAgents);
                }).catch(error => {
                    console.error("Error fetching users:", error);
                });
            }).catch(error => {
                console.error("Error fetching agents:", error);
            });
        }
    }, [auth.token, dialogOpen, userType]);

    useEffect(() => {
        const selectedAgent = agents.find(agent => agent.agent_id === agentId);
        if (selectedAgent) {
            setEmail(selectedAgent.email);
        }
    }, [agentId, agents]);

    const handleClose = () => {
        setDialogOpen(false);
    };


    function handleAddUser() {
        let data = {
            agent_id: agentId,
            full_name: fullName,
            nick_name: nickName,
            contact_number: contactNo,
            secondary_number: contactNo2,
            email: email,
            password: password,
            status: status,
            date_of_birth: dateOfBirth,
        };

        setLoading(true);

        let registerFn;

        if (userType === 'Agent') {
            registerFn = registerAgent;
        } else if (userType === 'Admin') {
            registerFn = registerAdmin;
        }

        registerFn({ token: auth.token, data }).then(response => {
            toast.success("User has been added.", {
                autoClose: 2000,
                hideProgressBar: true,
                icon: ({ theme, type }) => <CheckIcon sx={{ color: '#3328BF' }} />,
                closeButton: false
            });

            callback();

            setDialogOpen(false);

            clearForm();

            setLoading(false);
        }).catch(error => {
            setLoading(false);

            const result = displayErrors(error.response.data);

            if (!result) {
                toast.error(error.response.data.message, {
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeButton: false
                });
            }
        });
    }

    function handleUpdateAgent() {
        const data = {
            agent_id: agentId,
            full_name: fullName,
            nick_name: nickName,
            contact_number: contactNo,
            secondary_number: contactNo2,
            email: email,
            status: status,
            date_of_birth: dateOfBirth,
        }

        setLoading(true);

        updateAgent({ token: auth.token, data, userId: selectedUser.id }).then(response => {
            toast.success("User has been updated.", {
                autoClose: 2000,
                hideProgressBar: true,
                icon: ({ theme, type }) => <CheckIcon sx={{ color: '#3328BF' }} />,
                closeButton: false
            });

            callback();

            setDialogOpen(false);

            clearForm();

            setLoading(false);
        }).catch(error => {
            setLoading(false);

            const result = displayErrors(error.response.data);

            if (!result) {
                toast.error(error.response.data.message, {
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeButton: false
                });
            }
        });
    }

    function clearForm() {
        setAgentId('');
        setFullName('');
        setNickName('');
        setContactNo('');
        setContactNo2('');
        setEmail('');
        setPassword('');
        setConfirmPassword('');
        setStatus('');
    }

    function clearErrors() {
        setAgentIdError('');
        setFullNameError('');
        setNickNameError('');
        setContactNoError('');
        setContactNoError2('');
        setEmailError('');
        setPasswordError('');
        setConfirmPasswordError('');
        setStatusError('');
    }

    function displayErrors(data) {
        if (data.hasOwnProperty('errors')) {
            if (data.errors.hasOwnProperty('email')) {
                setEmailError(data.errors.email);
            }
        } else {
            return false;
        }


        return true;
    }

    function handleUpdateUser() {
        // const user = {
        //     'user_name': userName,
        //     'user_value': userValue,
        //     'user_currency': currency
        // }
        // // setIsLoading(true)

        // updateUser({ token: auth.token, userId: userParam.id, user }).then(res => {


        //     toast.success('User Updated Successfully', {
        //         autoClose: 1000,
        //         hideProgressBar: true,
        //         position: toast.POSITION.TOP_LEFT
        //     });

        //     setDialogOpen(false)
        //     callback()
        //     // setIsLoading(false)
        // })
    }

    function validate() {
        let isValid = true;

        const fullNameTrimmed = fullName.trim();
        const nickNameTrimmed = nickName.trim();
        const agentIdTrimmed = agentId ? agentId?.trim() : '';
        const contactNoTrimmed = contactNo ? contactNo?.trim() : '';
        const contactNo2Trimmed = contactNo2 ? contactNo2?.trim() : '';
        const emailTrimmed = email.trim();
        const passwordTrimmed = password.trim();
        const confirmPasswordTrimmed = confirmPassword.trim();
        const statusTrimmed = status.trim();

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        setAgentIdError('');
        setFullNameError('');
        setNickNameError('');
        setContactNoError('');
        setContactNoError2('');
        setEmailError('');
        setPasswordError('');
        setConfirmPasswordError('');
        setStatusError('');

        if (userType === 'Agent') {
            if (agentIdTrimmed === '') {
                setAgentIdError('Agent ID is required.');
                isValid = false;
            } else if (agentIdTrimmed.length > 20) {
                setAgentIdError('Agent ID is too long.');
                isValid = false;
            }
        }

        if (fullNameTrimmed === '') {
            setFullNameError('Full name is required.');
            isValid = false;
        } else if (fullNameTrimmed.length > 100) {
            setFullNameError('Full name is too long.');
            isValid = false;
        }

        if (nickNameTrimmed === '') {
            setNickNameError('Nick name is required.');
            isValid = false;
        } else if (nickNameTrimmed.length > 20) {
            setNickNameError('Nick name is too long.');
            isValid = false;
        }

        if (userType === 'Agent') {
            if (contactNoTrimmed === '') {
                setContactNoError('Contact no. is required.');
                isValid = false;
            } else if (contactNoTrimmed.length > 30) {
                setContactNoError('Contact no. is too long.');
                isValid = false;
            }

            if (contactNo2Trimmed.length > 50) {
                setContactNoError2('Contact no. 2 is too long.');
                isValid = false;
            }
        }

        if (emailTrimmed === '') {
            setEmailError('Email is required.');
            isValid = false;
        } else if (emailTrimmed.length > 50) {
            setEmailError('Email is too long.');
            isValid = false;
        } else if (!emailRegex.test(emailTrimmed)) {
            setEmailError('Invalid email address.');
            isValid = false;
        }

        if (mode === 'create') {
            if (passwordTrimmed === '') {
                setPasswordError('Password is required.');
                isValid = false;
            } else if (passwordTrimmed.length <= 6) {
                setPasswordError('Password is weak.');
                isValid = false;
            } else if (passwordTrimmed.length > 20) {
                setPasswordError('Password is too long.');
                isValid = false;
            }

            if (confirmPasswordTrimmed === '') {
                setConfirmPasswordError('Confirm password is required.');
                isValid = false;
            } else if (confirmPasswordTrimmed !== passwordTrimmed) {
                setConfirmPasswordError('Password does not match.');
                isValid = false;
            }
        }

        if (statusTrimmed === '') {
            setStatusError('Status is required.');
            isValid = false;
        }

        return isValid;
    }

    function handleSubmit() {
        // let isValid = validate();
        // if (mode === 'create') {
        //     if (isValid) {
        //         handleAddUser()
        //     }
        // } else if (mode === 'update') {
        //     if (isValid) {
        //         handleUpdateUser()
        //     }
        // }

        const isValid = validate();

        if (!isValid) {
            return;
        }
        if (mode === 'create') {
            handleAddUser();
        } else if (mode === 'update') {
            handleUpdateAgent();
        }

    }

    const handleClickShowPassword = () => {
        setShowPassword((prev) => !prev);
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };





    return (
        <Dialog
            open={dialogOpen}
            onClose={handleClose}
            sx={{ zIndex: 9998 }}
            ref={dialogRef}
        >
            <DialogTitle sx={{ mt: 2 }}>
                {mode == 'create' ? 'Add User' : 'Edit User'}
            </DialogTitle>

            <DialogContent>
                {/* <FormControl sx={{ mt: 1 }}>
                    <InputLabel id="select-user-type">User Type</InputLabel>
                    <Select
                        labelId="select-user-type"
                        value="Agent"
                        label=">User Type"
                        onChange={() => { }}
                    >
                        <MenuItem value="Agent">Agent</MenuItem>
                        <MenuItem value="Admin">Admin</MenuItem>
                    </Select>
                </FormControl> */}
                {
                    mode === 'create' && <FormControl sx={{ mt: 0 }}>
                        <FormLabel id="radio-user-type-label">User Type</FormLabel>
                        <RadioGroup
                            row
                            aria-labelledby="radio-user-type-label"
                            name="radio-user-type"
                            value={userType}
                            onChange={(e) => {
                                setUserType(e.target.value);
                            }}
                        >
                            <FormControlLabel value="Agent" control={<Radio />} label="Agent" />
                            <FormControlLabel value="Admin" control={<Radio />} label="Admin" />
                        </RadioGroup>
                    </FormControl>
                }

                <Grid2 container spacing={3} sx={{ mt: 1 }}>
                    <Grid2 size={{ xs: 12, md: userType === 'Agent' ? 6 : 12 }}>
                        <Typography sx={{ fontSize: 14, color: '#616161' }}>USER INFORMATION</Typography>

                        {
                            userType === 'Agent' && (
                                <Box sx={{ mt: 1 }}>
                                    <Typography sx={{ fontSize: 12, color: '#616161' }}>AGENT ID</Typography>
                                    <Select
                                        size='small'
                                        margin="dense"
                                        fullWidth
                                        variant="outlined"
                                        value={agentId}
                                        onChange={(e) => { setAgentId(e.target.value) }}
                                        error={agentIdError !== ''}
                                    >
                                        {agents.map(agent => (
                                            <MenuItem key={agent.agent_id} value={agent.agent_id}>
                                                {agent.agent_id}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                    <Typography sx={{ ml: 2, fontSize: 13, color: '#d32f2f', mt: 0.5 }}>{agentIdError}</Typography>
                                </Box>
                            )

                        }

                        <Box sx={{ mt: 1 }}>
                            <Typography sx={{ fontSize: 12, color: '#616161' }}>FULL NAME</Typography>
                            <TextField
                                size='small'
                                margin="dense"
                                type="text"
                                fullWidth
                                variant="outlined"
                                value={fullName}
                                onChange={(e) => { setFullName(e.target.value) }}
                                error={fullNameError !== ''}
                                helperText={fullNameError}
                            />
                        </Box>


                        <Box sx={{ mt: 1 }}>
                            <Typography sx={{ fontSize: 12, color: '#616161' }}>NICK NAME</Typography>
                            <TextField
                                size='small'
                                margin="dense"
                                type="text"
                                fullWidth
                                variant="outlined"
                                value={nickName}
                                onChange={(e) => { setNickName(e.target.value) }}
                                error={nickNameError !== ''}
                                helperText={nickNameError}
                            />
                        </Box>
                        {
                            userType === 'Agent' &&
                            <Box>
                                <Box sx={{ mt: 1 }}>
                                    <Typography sx={{ fontSize: 12, color: '#616161' }}>CONTACT NO.</Typography>
                                    <TextField
                                        size='small'
                                        margin="dense"
                                        type="text"
                                        fullWidth
                                        variant="outlined"
                                        value={contactNo}
                                        onChange={(e) => { setContactNo(e.target.value) }}
                                        error={contactNoError !== ''}
                                        helperText={contactNoError}
                                    />
                                </Box>

                                <Box sx={{ mt: 1 }}>
                                    <Typography sx={{ fontSize: 12, color: '#616161' }}>CONTACT NO 2.</Typography>
                                    <TextField
                                        size='small'
                                        margin="dense"
                                        type="text"
                                        fullWidth
                                        variant="outlined"
                                        value={contactNo2}
                                        onChange={(e) => { setContactNo2(e.target.value) }}
                                        error={contactNoError2 !== ''}
                                        helperText={contactNoError2}
                                    />
                                </Box>
                            </Box>
                        }

                    </Grid2>
                    <Grid2 size={{ xs: 12, md: userType === 'Agent' ? 6 : 12 }}>
                        <Typography sx={{ color: '#616161', fontSize: 14 }}>USER CREDENTIALS</Typography>
                        <Box sx={{ mt: 1 }}>
                            <Typography sx={{ fontSize: 12, color: '#616161' }}>EMAIL</Typography>
                            <TextField
                                size='small'
                                margin="dense"
                                type="email"
                                fullWidth
                                variant="outlined"
                                value={email}
                                onChange={(e) => { setEmail(e.target.value) }}
                                error={emailError !== ''}
                                helperText={emailError}
                                disabled={mode === 'view' || userType !== 'Admin'}
                            />
                        </Box>


                        {
                            mode === 'create' &&
                            <Box sx={{ mt: 1 }}>
                                <Typography sx={{ fontSize: 12, color: '#616161' }}>PASSWORD</Typography>
                                <OutlinedInput
                                    sx={{ mt: .5 }}
                                    size='small'
                                    type={showPassword ? 'text' : 'password'}
                                    fullWidth
                                    variant="outlined"
                                    value={password}
                                    onChange={(e) => { setPassword(e.target.value) }}
                                    error={passwordError !== ''}
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label={showPassword ? 'hide the password' : 'display the password'}
                                                onClick={handleClickShowPassword}
                                                onMouseDown={handleMouseDownPassword}
                                                edge="end"
                                            >
                                                {showPassword ? <VisibilityOff /> : <Visibility />}
                                            </IconButton>
                                        </InputAdornment>

                                    }
                                />
                                <Typography sx={{ ml: 2, fontSize: 13, color: '#d32f2f', mt: 0.5 }}>{passwordError}</Typography>
                            </Box>
                        }

                        {
                            mode === 'create' &&
                            <Box sx={{ mt: 1 }}>
                                <Typography sx={{ fontSize: 12, color: '#616161' }}>CONFIRM PASSWORD</Typography>
                                <OutlinedInput
                                    sx={{ mt: .5 }}
                                    size='small'
                                    type={showPassword ? 'text' : 'password'}
                                    fullWidth
                                    variant="outlined"
                                    value={confirmPassword}
                                    onChange={(e) => { setConfirmPassword(e.target.value) }}
                                    error={confirmPasswordError !== ''}
                                    helperText={confirmPasswordError}
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label={showPassword ? 'hide the password' : 'display the password'}
                                                onClick={handleClickShowPassword}
                                                onMouseDown={handleMouseDownPassword}
                                                edge="end"
                                            >
                                                {showPassword ? <VisibilityOff /> : <Visibility />}
                                            </IconButton>
                                        </InputAdornment>

                                    }
                                />

                                <Typography sx={{ ml: 2, fontSize: 13, color: '#d32f2f', mt: 0.5 }}>{confirmPasswordError}</Typography>
                            </Box>
                        }


                        <Box sx={{ mt: 2 }}>
                            <Typography sx={{ fontSize: 12, color: '#616161' }}>STATUS</Typography>
                            <Select
                                sx={{ mt: .5 }}
                                size='small'
                                fullWidth
                                onChange={(event) => {
                                    setStatus(event.target.value)
                                }}
                                value={status ?? ''}
                                error={statusError !== ''}
                                helperText={statusError}
                                readOnly={mode === 'view'}

                            >
                                <MenuItem value='Active'>Active</MenuItem>
                                <MenuItem value='Inactive'>Inactive</MenuItem>
                            </Select>

                            <Typography sx={{ ml: 2, fontSize: 13, color: '#d32f2f', mt: 0.5 }}>{statusError}</Typography>
                        </Box>
                        <Box sx={{ mt: 2 }}>
                            <Typography sx={{ fontSize: 12, color: '#616161' }}>DATE OF BIRTH</Typography>
                            <TextField
                                type="date"
                                variant="outlined"
                                size="small"
                                fullWidth
                                value={dateOfBirth}
                                onChange={(e) => setDateOfBirth(e.target.value)}
                                sx={{ mt: 0.5 }}
                            />
                            <Typography sx={{ ml: 2, fontSize: 13, color: '#d32f2f', mt: 0.5 }}>{dateOfBirthError}</Typography>
                        </Box>
                    </Grid2>
                </Grid2>
            </DialogContent>
            <DialogActions sx={{ mb: 3, px: 2 }}>
                <Button onClick={handleClose}>Cancel</Button>

                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Button
                        disabled={isLoading}
                        variant='contained'
                        onClick={handleSubmit}>{mode === 'create' ? 'Submit' : 'Update'}</Button>
                    {
                        isLoading &&
                        <CircularProgress size={24} sx={{ ml: 2 }} />
                    }
                </Box>
            </DialogActions>

        </Dialog>
    )
}

export default UserFormDialog

